import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const ManageRIBOForms = Loadable(
  lazy(() =>
    import("./RIBOForms").then(({ ManageRIBOForms }) => ({
      default: ManageRIBOForms,
    }))
  )
);

const RIBOFormsList = Loadable(
  lazy(() =>
    import("./RIBOFormsList").then(({ RIBOFormsList }) => ({
      default: RIBOFormsList,
    }))
  )
);

export const RIBOFormsRoutes = [
  {
    path: `/reports/ribo-forms-list`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <RIBOFormsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/reports/ribo-form-1/manage`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ManageRIBOForms />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/reports/ribo-form-1/manage/:id`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ManageRIBOForms />
      </AuthorizedRoute>
    ),
  },
];
